// Tiny shared singleton controlling the global SavedViewsDrawer's visibility.
// The app has no Vuex; this module-level reactive state lets any surface (the
// navbar icon, a FilterBar "manage views" row) open the one drawer instance
// mounted in DashboardLayout, without prop/event plumbing through the tree.

import { reactive } from 'vue'

const state = reactive({ isOpen: false })

export function openSavedViews(): void {
  state.isOpen = true
}

export function closeSavedViews(): void {
  state.isOpen = false
}

export function useSavedViewsDrawer() {
  return state
}
